import { useQuery } from '@tanstack/react-query';
import { endpoints } from '@rossum/api-client';
import { api } from '../../../../lib/apiClient';

type Props = {
  enabled?: boolean;
  documentIds: number[];
};

export const useFetchDocuments = ({ documentIds }: Props) => {
  const query = { id: documentIds };
  return useQuery({
    queryKey: ['documents', 'list', query],
    queryFn: async () => {
      const response = await api.request(endpoints.documents.list(query));
      return response;
    },
    enabled: Boolean(documentIds.length),
  });
};
